import Swiper, { Navigation, Pagination } from 'swiper'
Swiper.use([ Navigation, Pagination ])

class StepList {
  
  constructor (el) {
    this.el = el
    this.sliderContainer = el.querySelector('.js-steps-list-slider')
    this.slider = null

    this.initDefault()
  }

  initDefault () {
    this.initSlider()
  }

  initSlider () {
    this.slider = new Swiper( this.sliderContainer, {
      spaceBetween: 24,
      slidesPerView: 3,
      simulateTouch: false,
      observeParents: true,
      observer: true,
      breakpoints: {
        0: {
          spaceBetween: 16,
          slidesPerView: 1
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 3
        },
        1024: {
          spaceBetween: 24,
          slidesPerView: 3
        }
      },
      navigation: {
        prevEl: '.js-slider-control-prev',
        nextEl: '.js-slider-control-next'
      },
      pagination: {
        el: '.js-slider-control-pagination',
        clickable: true
      }
    })
  }

}

document.addEventListener('DOMContentLoaded', e => {
  const el = document.querySelector('.js-steps-list')
  if ( el ) {
    new StepList(el)
  }
})